import SmoothScroll from "smooth-scroll";

window.addEventListener("DOMContentLoaded", event => {
  const scroll = new SmoothScroll('a[href*="#"]');
});
